export const infoMessages = {
  APPLICATION_APPROVED: 'Ваша заявка була узгоджена.',
  APPLICATION_REJECTED: 'Ваша заявка була відхилена.',
  APPLICATION_CLOSED: 'Ваша заявка була закрита.',
  APPLICATION_NUMBER_SENT: 'Номер заявки був надісланий на зазначений при реєстрації e-mail.',
  DOCUMENTS_SIGNED_AND_SENT:
    'Ми раді повідомити, що документи успішно підписані та відправлені в Банк. Очікуйте повідомлення про результат найближчим часом.',
  DOCUMENTS_SENT: 'Ми раді повідомити, що документ успішно підписаний і відправлений в Банк.',
  APPLICATION_SENT_FOR_SIGNING: 'Заявка відправлена на підписання клієнту.',
  APPLICATION_DOCUMENTS_ACCEPTED: 'Ваші заявка та документи прийняті.',
  ALREADY_REGISTERED:
    'Ви вже є зареєстрованим клієнтом Банку, будь ласка, зверніться до найближчого відділення за додатковими послугами.',
  APPLICATION_CREATED: 'Посилання на заповнення згоди відправлено на вказану пошту!',
  INSTRUCTIONS_IN_EMAIL: 'Посилання на заповнення відкликання згоди відправлено на вказану пошту!',
  LIMITED_ACCESS_TO_FUNCTIONALITY:
    'Ви авторизовані як менеджер. Цей функціонал доступний для клієнта банку, перезайдіть як клієнт для розблокування.',
  FOLLOW_DIIA_SIGN_INSTRUCTIONS:
    'Дотримуйтесь подальших інструкцій в застосунку Дія для підпису необхідних документів',
  DATA_SUCCESSFULLY_UPDATED: 'Ваші дані успішно оновлені!',
  MESSAGE_APPLICATION_CREATED: 'Посилання на актуалізацію даних відправлено на вказану пошту!',
  OPEN_AN_ACCOUNT:
    'Для початку співпраці з Банком та відкриття рахунку натисніть кнопку «Відкрити рахунок».',
  UPDATE_DATA:
    'Ми знайшли ваш профіль у нашій системі. Якщо ви хочете оновити дані натисніть кнопку "Оновити дані". Якщо Ви хочете відкрити додатковий рахунок - скористайтеся сервісами клієнт-банку',
  RE_VERIFICATION_MESSAGE:
    'Дані в цьому розділі передзаповнені з вашої попередньої анкети. Будь ласка, перевірте та оновіть інформацію, якщо вона змінилась.',
  UPDATE_OF_DISTRIBUTOR_DATA_MESSAGE:
    'Увага! За результатом опрацювання заявки контактні дані уповноважених осіб (розпорядників рахунків) будуть оновлені в інформаційних системах АТ "Укрексімбанк"',
  SEND_LETTER:
    'Листи на підтвердження актуальності контактних даних успішно відправлено визначеному переліку уповноважених осіб.',
  RE_IDENTIFICATION_FOP_DOCUMENTS_SIGNED_AND_SENT:
    'Ми раді повідомити, що документи для оновлення даних успішно підписані та відправлені в Банк. Очікуйте повідомлення про успішне оновлення даних найближчим часом.',
  PASSWORD_RECOVERY_MESSAGE:
    "Інструкції щодо зміни пароля надіслано на вказаний email, за умови, що цей акаунт існує. Якщо лист не надійшов протягом 5-10 хвилин, перевірте правильність введених даних або папку 'Спам'.",
  LOGIN_DURING_REGISTRATION:
    'Логін має бути від 5 до 20 символів і може містити лише латинські або кириличні літери та цифри (0-9)',
  PASSWORD_DURING_REGISTRATION:
    'Пароль повинен містити мінімум 8 символів і включати великі літери (A-Z), малі літери (a-z), цифри (0-9) та спеціальні символи (наприклад, !, @, #, $, %).',
  SAVE_CHANGES: 'Зберегти зміни?',
  IBAN_INFORMER: `Вкажіть номери рахунків (IBAN) цієї організації, що обслуговуються в АТ "Укрексімбанк". Рахунки в інших банках не вказуються. Якщо ви тільки встановлюєте ділові стосунки із Банком та/або організація не маєте відкритих рахунків - IBAN не обов'язковий та може не зазначатись`,
  FATCA_FOP_FALSE_INFORMER:
    'Обравши «Ні», Ви підтверджуєте, що не є ні громадянином США, ні податковим резидентом США. У тому числі Ви підтверджуєте, що не маєте United States Permanent Resident Card (USPRC, «Green Card», форма I-551) і не маєте суттєвої присутності в США (не перебували в США 31 день чи більше протягом поточного року та/або 183 і більше днів за останні три роки).',
  FATCA_FOP_TRUE_INFORMER:
    "Ці дані буде внесено до «Анкети-опитувальника» (блок IV, секція №25). Форма W-9 та копія TIN з'являться в розділі «Документи» → «Обов'язкові документи».",
};

export const INDICATORS = {
  ADD_YOUR_OWN_OPTION: 'Натисніть Enter щоб додати свій варіант',
  OPTION_ABSENT: 'Така опція відсутня',
};
